import { Text } from "@/components/ui/text";
import { HStack } from "@/components/ui/hstack";
import React from 'react';

export default function InfoElement({ header, mainText, secondaryText }) {
    return (
        <>
            {header && <Text className="text-2xl leading-2xl mb-[5px] mt-[2px] text-secondary-900">{header}</Text>}
            <HStack className="justify-between px-3 mt-[5px]">
                <Text className="text-xl leading-xl text-secondary-900"> {mainText} </Text>
                <Text className="text-xl leading-xl text-secondary-900"> {secondaryText} </Text>
            </HStack>
        </>
    );
}